import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { checkStatus, loginBuilderUser, loginUser } from "../../services/auth";
import { getIsOnBuilderWebsite } from "../../utils/isBuilderWebsite";

// selectors

export const selectMyUserId = state => state.auth.currentUser?.id;
export const selectMyRetailerId = state => state.auth.currentUser?.RetailerId;

// actions

export const loginAsync = createAsyncThunk("auth/signin", async payload => {
  const user = await loginUser(payload);
  return user;
});

export const loginBuilderAsync = createAsyncThunk("auth/builder/signin", async payload => {
  const user = await loginBuilderUser(payload);
  return user;
});

export const logoutAsync = createAsyncThunk("auth/signout", async payload => {
  const isOnBuilderSite = getIsOnBuilderWebsite();
  const path = isOnBuilderSite ? "/api/auth/builder/signout" : "/api/auth/signout";
  const response = await axios.post(path, payload);
  return response.data;
});

export const checkAuthStatusAsync = createAsyncThunk("auth/status", async () => {
  const user = await checkStatus();
  return user;
});

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    loading: true,
    error: null,
    isAuthenticated: false,
    currentUser: null,
    loginModalShowing: false,
    activeAuthForm: "signIn", // or "resetPassword", "signUp"
    redirectOnCloseTo: null,
  },
  reducers: {
    clearErrors: state => {
      state.error = null;
    },
    setLoginModalState: (state, action) => {
      if (undefined !== action.payload.loginModalShowing) {
        state.loginModalShowing = action.payload.loginModalShowing;
      }
      if (action.payload.activeAuthForm) {
        state.activeAuthForm = action.payload.activeAuthForm;
      }
      if (action.payload.redirectOnCloseTo) {
        state.redirectOnCloseTo = action.payload.redirectOnCloseTo;
      } else {
        state.redirectOnCloseTo = null;
      }
    },
  },
  extraReducers: {
    [loginAsync.pending]: state => {
      state.loading = true;
    },
    [loginAsync.fulfilled]: (state, action) => {
      state.loading = false;
      if (!action.payload.id) {
        state.error = "Wrong username or password";
      } else {
        state.error = null;
        state.currentUser = action.payload;
        state.isAuthenticated = true;
      }
    },
    [loginAsync.rejected]: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.error = "Invalid credentials";
    },
    [loginBuilderAsync.pending]: state => {
      state.loading = true;
    },
    [loginBuilderAsync.fulfilled]: (state, action) => {
      state.loading = false;
      if (!action.payload.id) {
        state.error = "Wrong username or password";
      } else {
        state.error = null;
        state.currentUser = action.payload;
        state.isAuthenticated = true;
      }
    },
    [loginBuilderAsync.rejected]: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.error = "Invalid credentials";
    },
    [logoutAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.currentUser = null;
    },
    [checkAuthStatusAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.isAuthenticated = action.payload.isAuthenticated;
      state.currentUser = action.payload.currentUser;
    },
    [checkAuthStatusAsync.rejected]: (state, action) => {
      state.loading = false;
      state.isAuthenticated = false;
      state.currentUser = null;
    },
  },
});
export const { clearErrors, setLoginModalState } = authSlice.actions;
export default authSlice.reducer;
